var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import '../types';
/**
 * Suggested sizes endpoint.
 *
 * @todo make this not v2?
 */
const ENDPOINT_ART_CONTRIBUTOR = '/art/api/contributors';
/**
 * Art suggestions endpoint
 */
const ENDPOINT_ART_SUGGESTIONS = '/art/api/suggest';
/**
 * Update cart endpoint.
 */
const ENDPOINT_LOCALE = '/api/locale';
/**
 * Update cart endpoint.
 */
const ENDPOINT_LOGIN = '/account/login';
/**
 * Add giftcard to cart endpoint.
 */
const ENDPOINT_LOADING_CART_ADD_GIFTCARD = '/add-giftcard';
/**
 * Add coupon to cart endpoint.
 */
const ENDPOINT_LOADING_CART_ADD_COUPON = '/apply-coupon';
/**
 * Add edit proof endpoint.
 */
const ENDPOINT_EDIT_PROOF = '/account/edit-proof';
/**
 * Creates the axios client for the builder.
 */
const apiClient = (isForm = false) => axios.create({
    responseType: 'json',
    headers: {
        'Content-Type': isForm ? 'multipart/form-data' : 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
});
/**
 * Creates the axios client for the cart.
 */
const apiCart = axios.create({
    baseURL: '/cart',
    responseType: 'json',
    headers: {
        'Content-Type': 'multipart/form-data',
        'X-Requested-With': 'XMLHttpRequest',
    },
});
const fetchArtSuggestions = (term) => __awaiter(void 0, void 0, void 0, function* () {
    return apiClient().get(`${ENDPOINT_ART_SUGGESTIONS}?term=${term}`);
});
/**
 * Updates the user's region, currency, and language.
 */
const localeUpdate = (data) => {
    return apiClient().post(ENDPOINT_LOCALE, data);
};
/**
 * Logs in a user.
 */
const login = (data) => {
    return apiClient(true).post(ENDPOINT_LOGIN, data);
};
/*
 * Updates a product in the cart.
 */
const cartAddGiftcard = (data) => {
    return apiCart.post(ENDPOINT_LOADING_CART_ADD_GIFTCARD, data);
};
/*
 * Adds a giftcard or coupon to the cart
 */
const cartAddCoupon = (data) => {
    return apiCart.post(ENDPOINT_LOADING_CART_ADD_COUPON, data);
};
/*
 * Updates a customer's proof state
 */
const editProof = (data) => {
    return apiClient(true).post(ENDPOINT_EDIT_PROOF, data);
};
export { fetchArtSuggestions, localeUpdate, login, cartAddGiftcard, editProof, cartAddCoupon };
